import Swiper, { Navigation, Scrollbar, Autoplay } from "swiper";

import "./style.css";

export default class About {
  static selector = ".about";

  constructor(block) {
    this.block = block;

    this.esgCarousel = this.block.querySelector(
      ".about__planet-future-carousel"
    );
    this.esgCarouselPrevButton = this.block.querySelector(
      ".swiper-button-prev"
    );
    this.esgCarouselnextButton = this.block.querySelector(
      ".swiper-button-next"
    );
    this.scrollbar = this.block.querySelector(
      ".about__planet-future-navigation__scrollbar"
    );
    this.slides = Array.from(this.block.querySelectorAll(".swiper-slide"));
  }

  onReady = () => {
    if (this.slides.length > 1) {
      this.swiper = new Swiper(this.esgCarousel, {
        modules: [Scrollbar, Navigation /* , Autoplay */],
        wrapperClass: "about__planet-future-carousel-inner",
        navigation: {
          nextEl: this.esgCarouselnextButton,
          prevEl: this.esgCarouselPrevButton
        },
        slideToClickedSlide: true,
        scrollbar: {
          el: this.scrollbar,
          draggable: true,
          dragClass: "about__planet-future-navigation__scrollbar-drag",
          hide: false
        },
        autoplay: {
          delay: 5000
        },
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false
      });
    }
  };

  onDestroy = () => {
    if (this.swiper) {
      this.swiper.destroy();
    }
  };
}
